/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */
import { Component, Input } from '@angular/core';

import { FamilyMemberBaseContainerComponent as BaseContainer }
  from '../family-member-base-container/family-member-base-container.component';
import FamilyMember from '../family-member.model';
import { FamilyMemberService } from '../family-member.service';

/**
 * Component that houses the Family Members connected to the current account.
 */
@Component({
  selector: 'connected-family-members',
  templateUrl: './connected-family-members.component.html',
  providers: [FamilyMemberService],
  standalone: false,
})
export class ConnectedFamilyMembersComponent extends BaseContainer {
  // Input bound DOM element that references the family-members, associated members of the parent / guardian
  @Input() familyMembers: Array<FamilyMember>;

  constructor(public FamilyMemberService: FamilyMemberService) {
    super();
  }

  scrollToAnchor(id) {
    this.FamilyMemberService.scrollToAnchor(id);
  }
}
